/** True on iPhone / iPad / iPod WebKit browsers. */
export function isAppleMobileWebKit(): boolean {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua);
}
